import TR from 'utils/TR';
import Segment from 'components/common/Segment';
import T from 'utils/T';
import ex from 'utils/ex';
import CHECK_COLORS from 'constants/CHECK_COLORS';

export default function CVBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    cv,
  } = data || {};

  return (
    <Segment {...ex(['OverviewSummaryBox', 'CVBox', 'normal'], rest)}>
      <div>
        {T('CV')}
      </div>
      <div>
        <div {...ex(['BASE_COLOR', CHECK_COLORS('CV', cv)])}>
          {cv}
        </div>
        <div>
          {T('%')}
        </div>
      </div>
    </Segment>
  );
}
